import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model, referenceMany, referenceOne } from 'libx';
import identity from 'lodash/identity';
import { computed, observable } from 'mobx';
import moment from 'moment';
import { makeMomentSorter } from 'utils/arrayUtil';
import { consolidateSchedules } from '../utils/jobUtil';
import { omitUndefined } from '../utils/objectUtil';
import Amendment from './Amendment';
import Milestone from './Milestone';
import Consultation from './Consultation';
import flatMap from 'lodash/flatMap';
import { getFeatureToggleClient } from '../misc/featureToggles';
var Job = (_dec = observable.ref, _dec2 = observable.shallow, _class = /*#__PURE__*/function (_Model) {
  function Job() {
    var _this;
    _classCallCheck(this, Job);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Job, [].concat(args));
    _initializerDefineProperty(_this, "adminFeeAmount", _descriptor, _this);
    _initializerDefineProperty(_this, "amendedAmount", _descriptor2, _this);
    _initializerDefineProperty(_this, "amendments", _descriptor3, _this);
    _initializerDefineProperty(_this, "answers", _descriptor4, _this);
    _initializerDefineProperty(_this, "billingType", _descriptor5, _this);
    _initializerDefineProperty(_this, "conversation", _descriptor6, _this);
    _initializerDefineProperty(_this, "conversationId", _descriptor7, _this);
    _initializerDefineProperty(_this, "couponAmount", _descriptor8, _this);
    _initializerDefineProperty(_this, "couponCodes", _descriptor9, _this);
    _initializerDefineProperty(_this, "couponIds", _descriptor10, _this);
    _initializerDefineProperty(_this, "dateClosed", _descriptor11, _this);
    _initializerDefineProperty(_this, "dateCreated", _descriptor12, _this);
    _initializerDefineProperty(_this, "dateModified", _descriptor13, _this);
    _initializerDefineProperty(_this, "dateReopened", _descriptor14, _this);
    _initializerDefineProperty(_this, "dateTransmitted", _descriptor15, _this);
    _initializerDefineProperty(_this, "dateDeadline", _descriptor16, _this);
    _initializerDefineProperty(_this, "grossAmount", _descriptor17, _this);
    _initializerDefineProperty(_this, "federalAmount", _descriptor18, _this);
    // this was not always present.
    _initializerDefineProperty(_this, "jobSpecs", _descriptor19, _this);
    _initializerDefineProperty(_this, "jobScopeItems", _descriptor20, _this);
    _initializerDefineProperty(_this, "name", _descriptor21, _this);
    _initializerDefineProperty(_this, "shortId", _descriptor22, _this);
    _initializerDefineProperty(_this, "paidAmount", _descriptor23, _this);
    _initializerDefineProperty(_this, "primaryAmount", _descriptor24, _this);
    _initializerDefineProperty(_this, "providerCut", _descriptor25, _this);
    _initializerDefineProperty(_this, "providerCutAmount", _descriptor26, _this);
    _initializerDefineProperty(_this, "stateAmount", _descriptor27, _this);
    // this was not always present.
    _initializerDefineProperty(_this, "states", _descriptor28, _this);
    _initializerDefineProperty(_this, "status", _descriptor29, _this);
    _initializerDefineProperty(_this, "paymentInfoStatus", _descriptor30, _this);
    _initializerDefineProperty(_this, "total", _descriptor31, _this);
    _initializerDefineProperty(_this, "unseenMessagesCount", _descriptor32, _this);
    _initializerDefineProperty(_this, "workspaceId", _descriptor33, _this);
    _initializerDefineProperty(_this, "years", _descriptor34, _this);
    _initializerDefineProperty(_this, "legendName", _descriptor35, _this);
    _initializerDefineProperty(_this, "legendId", _descriptor36, _this);
    _initializerDefineProperty(_this, "legendVersion", _descriptor37, _this);
    _initializerDefineProperty(_this, "legend", _descriptor38, _this);
    _initializerDefineProperty(_this, "members", _descriptor39, _this);
    _initializerDefineProperty(_this, "milestones", _descriptor40, _this);
    _initializerDefineProperty(_this, "infoLines", _descriptor41, _this);
    _initializerDefineProperty(_this, "ownerTeamId", _descriptor42, _this);
    _initializerDefineProperty(_this, "teamIds", _descriptor43, _this);
    _initializerDefineProperty(_this, "requestedProId", _descriptor44, _this);
    _initializerDefineProperty(_this, "requestedProPublicId", _descriptor45, _this);
    _initializerDefineProperty(_this, "archived", _descriptor46, _this);
    _initializerDefineProperty(_this, "waitingOn", _descriptor47, _this);
    _initializerDefineProperty(_this, "consultation", _descriptor48, _this);
    _initializerDefineProperty(_this, "jobType", _descriptor49, _this);
    return _this;
  }
  _inherits(Job, _Model);
  return _createClass(Job, [{
    key: "provider",
    get: function get() {
      var jobMember = this.members.find(function (x) {
        return x.role === 'CHAMPION' && x.type === 'PROVIDER';
      }) || null;
      if (!jobMember) {
        return null;
      }
      return jobMember.user;
    }
  }, {
    key: "client",
    get: function get() {
      var jobMember = this.members.find(function (x) {
        return x.role === 'CHAMPION' && x.type === 'CLIENT';
      }) || null;
      if (!jobMember) {
        return null;
      }
      return jobMember.user;
    }
  }, {
    key: "currentUserCollaborator",
    get: function get() {
      return this.members.find(function (m) {
        return m.user.isCurrentUser;
      }) || null;
    }
  }, {
    key: "workspace",
    get: function get() {
      return referenceOne(this.rootStore.workspaceStore.workspaces, this.workspaceId);
    }
  }, {
    key: "providers",
    get: function get() {
      return this.members.filter(function (x) {
        return x.type === 'PROVIDER';
      });
    }
  }, {
    key: "completed",
    get: function get() {
      return this.status === 'CLOSED';
    }
  }, {
    key: "projectType",
    get: function get() {
      return this.legend ? this.legend.id : null;
    }
  }, {
    key: "documents",
    get: function get() {
      return this.rootStore.documentStore.forJob(this.id);
    }
  }, {
    key: "unreadCount",
    get: function get() {
      return this.rootStore.messageStore.unreadIn(this.conversationId);
    }
  }, {
    key: "events",
    get: function get() {
      var _this2 = this;
      return this.rootStore.eventStore.jobEvents.filter(function (x) {
        return x.jobId === _this2.id;
      }).sort(makeMomentSorter('desc', function (x) {
        return x.dateCreated;
      }));
    }
  }, {
    key: "due",
    get: function get() {
      return (this.dateReopened ? this.dateReopened : this.dateTransmitted || this.dateCreated).clone()
      // Hardcoded for now.
      .add(7, 'days')
      // When using `fromNow()` we always want the string in english.
      .locale('en-US');
    }
  }, {
    key: "openedDuration",
    get: function get() {
      var end = this.dateClosed ? this.dateClosed.clone().utc().startOf('day') : moment().utc().startOf('day');
      var start = this.dateCreated.clone().utc().startOf('day');
      return moment.duration(end.diff(start));
    }
  }, {
    key: "formattedJobSpecs",
    get: function get() {
      return consolidateSchedules(this.jobSpecs);
    }
  }, {
    key: "jobScopeItemsNames",
    get: function get() {
      return this.jobScopeItems.map(function (item) {
        return item.name;
      });
    }
  }, {
    key: "formattedJobSpecsWithInvItems",
    get: function get() {
      return this.jobScopeItemsNames;
    }
  }, {
    key: "timeline",
    get: function get() {
      console.warn(new Error('job.timeline should not be used and will go away soon.'));
      return [{
        date: this.dateCreated,
        text: 'Job created',
        type: 'pending'
      }, this.dateTransmitted && {
        date: moment(this.dateTransmitted),
        text: "Submitted",
        type: 'pending'
      }, this.dateAccepted && {
        date: moment(this.dateAccepted),
        text: "Job picked up by ".concat(this.provider.displayName),
        type: 'pending'
      }, !this.dateClosed && this.dateReopened && {
        date: moment(this.dateReopened),
        text: 'Job reopened',
        type: 'pending'
      }, this.dateClosed && {
        date: this.dateClosed,
        text: 'Job completed',
        type: 'success'
      }].filter(identity);
    }
  }, {
    key: "statusMessage",
    get: function get() {
      switch (this.status) {
        case 'UNDER_CONSTRUCTION':
          return 'Under Construction';
        case 'INFO_GATHERING':
          return 'Info Gathering';
        case 'UNCLAIMED':
          {
            return 'Submitted';
          }
        case 'ON_HOLD':
          return 'On Hold';
        case 'IDLE':
          return 'Idle - Needs your attention!';
        case 'CLAIMED':
          {
            if (this.milestones.length === 0) {
              return 'In Progress';
            }
            var currentMilestone = this.milestones.find(function (x) {
              return !x.completed;
            });
            if (!currentMilestone) {
              return 'Finalizing';
            }
            return "".concat(currentMilestone.title, " (").concat(currentMilestone.tasks.filter(function (t) {
              return t.completed;
            }).length, "/").concat(currentMilestone.tasks.length, ")");
          }
        case 'CLOSED':
          return 'Completed';
        default:
          return 'N/A';
      }
    }
  }, {
    key: "relevantStatusDate",
    get: function get() {
      switch (this.status) {
        case 'UNDER_CONSTRUCTION':
          return this.dateCreated;
        case 'UNCLAIMED':
          return this.dateTransmitted;
        case 'CLAIMED':
          return this.dateAccepted;
        case 'IDLE':
          return this.lastStaleDate;
        case 'CLOSED':
          return this.dateClosed;
        default:
          return this.dateModified;
      }
    }
  }, {
    key: "ownerTeam",
    get: function get() {
      return referenceOne(this.rootStore.teamStore.teams, this.ownerTeamId);
    }
  }, {
    key: "teams",
    get: function get() {
      return referenceMany(this.rootStore.teamStore.teams, this.teamIds, 'id');
    }
  }, {
    key: "isDeadlineRelevant",
    get: function get() {
      if (!this.dateDeadline) {
        return false;
      }
      var deadline = Date.parse(this.dateDeadline);
      var dateCreated = Date.parse(this.dateCreated);
      return dateCreated < deadline || this.status !== 'UNDER_CONSTRUCTION';
    }
  }, {
    key: "hasClientTasks",
    get: function get() {
      var tasks = flatMap(this.milestones, function (m) {
        return m.tasks;
      });
      return tasks.some(function (t) {
        return t.designee === 'Client';
      });
    }
  }, {
    key: "isInProgress",
    get: function get() {
      return this.status === 'CLAIMED' || this.status === 'IDLE' || this.status === 'ON_HOLD';
    }
  }, {
    key: "isJobProgressionFlowEnabled",
    get: function get() {
      var _workspaceConfig$job_, _workspaceConfig$job_2, _workspaceConfig$job_3, _workspaceConfig$job_4;
      var newJobProgressionConfig = getFeatureToggleClient().variation('HQ.UseUpdatedJobProgressionConfig', false);
      var workspaceConfig = this.workspace.config;
      var progressionConfigIsEnabledAndNotNone = ((_workspaceConfig$job_ = workspaceConfig.job_progression_config) === null || _workspaceConfig$job_ === void 0 ? void 0 : _workspaceConfig$job_.enabled) && ((_workspaceConfig$job_2 = workspaceConfig.job_progression_config) === null || _workspaceConfig$job_2 === void 0 ? void 0 : _workspaceConfig$job_2.legends[this.legendId]) && ((_workspaceConfig$job_3 = workspaceConfig.job_progression_config) === null || _workspaceConfig$job_3 === void 0 ? void 0 : _workspaceConfig$job_3.legends[this.legendId]) !== 'NONE';
      var oldConfigIsEnabled = (_workspaceConfig$job_4 = workspaceConfig.job_config) === null || _workspaceConfig$job_4 === void 0 ? void 0 : _workspaceConfig$job_4.job_progression_flow;
      var jobProgressionFlowEnabled = newJobProgressionConfig ? progressionConfigIsEnabledAndNotNone : oldConfigIsEnabled;
      return !!jobProgressionFlowEnabled;
    }
  }, {
    key: "parse",
    value: function parse(json) {
      var _this3 = this;
      var conversation = json.layerConversation ? this.rootStore.messageStore.conversations.set({
        id: json.layerConversation
      }) : undefined;
      return omitUndefined({
        id: json.id,
        shortId: json.short_id,
        name: json.name || json.description || json.legend_name || '',
        providerId: json.provider_user_id,
        workspaceId: json.workspace_id,
        couponCodes: json.coupon_codes,
        couponIds: json.coupon_ids,
        infoLines: json.info_lines,
        ownerTeamId: json.owner_team_id,
        teamIds: json.team_ids,
        paymentInfoStatus: json.payment_info_status,
        legendName: json.legend_name || json.description || json.legend && json.legend.name,
        legendId: json.legend_id,
        legendVersion: json.legend_version,
        members: json.members && json.members.map(function (m) {
          return _objectSpread(_objectSpread(_objectSpread({}, m), m.team_id && {
            teamId: m.team_id
          }), {}, {
            user: _this3.rootStore.memberStore.setAndFetch(_objectSpread({
              workspace_id: json.workspace_id || _this3.workspaceId
            }, m.user))
          });
        }),
        conversation: conversation,
        conversationId: json.layerConversation,
        amendments: json.amendments ? json.amendments.map(function (x) {
          return new Amendment(_objectSpread(_objectSpread({}, x), {}, {
            workspace_id: json.workspace_id || _this3.workspaceId
          }), {
            parse: true,
            stripUndefined: true,
            rootStore: _this3.rootStore,
            job: _this3
          });
        }) : undefined,
        billingType: json.billing_type,
        legend: json.legend,
        answers: json.answers,
        states: json.coverage_states,
        status: json.status,
        resolution: json.resolution,
        resolution_reason: json.resolution_reason,
        years: json.years,
        total: json.total,
        milestones: json.milestones ? json.milestones.map(function (m) {
          return new Milestone(_objectSpread(_objectSpread({}, m), {}, {
            job: _this3,
            workspace_id: json.workspace_id || _this3.workspaceId
          }), {
            parse: true,
            rootStore: _this3.rootStore
          });
        }) : undefined,
        adminFeeAmount: json.admin_fee_amount,
        paidAmount: json.paid_amount,
        primaryAmount: json.primary_amount,
        stateAmount: json.state_amount,
        federalAmount: json.federal_amount,
        couponAmount: json.coupon_amount,
        amendedAmount: json.amended_amount,
        jobSpecs: json.job_specs,
        providerCutAmount: json.provider_cut_amount,
        dateCreated: moment(json.date_created),
        dateModified: moment(json.date_modified),
        dateClosed: json.date_closed ? moment(json.date_closed) : json.date_closed,
        dateAccepted: json.date_accepted ? moment(json.date_accepted) : json.date_accepted,
        dateDeadline: json.date_deadline ? moment(json.date_deadline) : json.date_deadline,
        dateTransmitted: json.date_transmitted ? moment(json.date_transmitted) : json.date_transmitted,
        dateReopened: json.date_reopened ? moment(json.date_reopened) : json.date_reopened,
        lastStaleDate: json.last_stale_date ? moment(json.last_stale_date) : json.last_stale_date,
        stale: json.stale,
        purge_status: json.purge_status,
        payoutTotal: json.payout_total,
        transactions: json.stripe_charges,
        stripePayouts: json.stripe_payouts,
        requestedProId: json.requested_pro_id,
        requestedProPublicId: json.requested_pro_public_id,
        archived: json.archived,
        waitingOn: json.waiting_on,
        consultation: json.consultation ? new Consultation(_objectSpread({}, json.consultation), {
          parse: true,
          rootStore: this.rootStore
        }) : undefined,
        jobType: json.type,
        jobScopeItems: json.job_scope_items ? json.job_scope_items.map(function (item) {
          return {
            id: item.id,
            name: item.name,
            description: item.description,
            price: item.price,
            pro_price: item.pro_price
          };
        }) : undefined
      });
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "adminFeeAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "amendedAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "amendments", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "answers", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "billingType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'STRIPE';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "conversation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "conversationId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "couponAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "couponCodes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "couponIds", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "dateClosed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "dateCreated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "dateModified", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "dateReopened", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "dateTransmitted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "dateDeadline", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "grossAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "federalAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "jobSpecs", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "jobScopeItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "name", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "shortId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "paidAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "primaryAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "providerCut", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "providerCutAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "stateAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "states", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "status", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'UNDER_CONSTRUCTION';
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "paymentInfoStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'NOT_PROVIDED';
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "total", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "unseenMessagesCount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "years", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "legendName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "legendId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "legendVersion", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "legend", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "members", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "milestones", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "infoLines", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "ownerTeamId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "teamIds", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "requestedProId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "requestedProPublicId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "archived", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "waitingOn", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "consultation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "jobType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "provider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "provider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "client", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentUserCollaborator", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentUserCollaborator"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "workspace", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "workspace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "providers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "providers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "completed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "completed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "projectType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "projectType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "documents", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "documents"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unreadCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unreadCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "events", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "events"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "due", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "due"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openedDuration", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "openedDuration"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedJobSpecs", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "formattedJobSpecs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "jobScopeItemsNames", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "jobScopeItemsNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedJobSpecsWithInvItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "formattedJobSpecsWithInvItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeline", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeline"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "statusMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "statusMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "relevantStatusDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "relevantStatusDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ownerTeam", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "ownerTeam"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teams", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "teams"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDeadlineRelevant", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeadlineRelevant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasClientTasks", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasClientTasks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInProgress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInProgress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isJobProgressionFlowEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isJobProgressionFlowEnabled"), _class.prototype), _class);
export { Job as default };
//# sourceMappingURL=Job.js.map
